import AssessmentTaker from "pages/PanelPage/components/selectedAssessment/assessmentResults/AssessmentTaker/AssessmentTaker";

export default AssessmentTaker;
